import { Routes, Route, useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../../components/useAuth";
import { useForm } from "react-hook-form";
import "./Announcement.css"; // ★ お知らせと共通のデザイン

const DocsRow = (props) => {
  return (
    <div className="ann-row ann-row-body">
      <div className="ann-col ann-col-doc-title">{props.title}</div>
      <div className="ann-col ann-col-doc-url" title={props.url}>
        <Link to={props.url} target="_blank">
          {props.url}
        </Link>
      </div>
      <div className="ann-col ann-col-category">{props.category}</div>
      <div className="ann-col ann-col-actions">
        <Link
          to={"/docs/" + props.id}
          data-id={props.id}
          className="btn btn-ghost btn-sm"
          style={{ marginRight: "0.2rem" }}
        >
          編集
        </Link>
        <Link
          to={"/docs/delete/" + props.id}
          data-id={props.id}
          className="btn btn-danger btn-sm"
        >
          削除
        </Link>
      </div>
    </div>
  );
};

const api_url = "https://api.ope-note.jp/admin/docs.php";

const DocsHome = () => {
  const [itemList, setItemList] = useState([]);
  const [page, setCurrentPage] = useState(1);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const getItemList = async () => {
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ page: page, mode: "list", token: token }),
        });

        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("404 error");
          }
          if (response.status === 401) {
            throw new Error("401 error");
          }
          throw new Error(response.status);
        }
        const data = await response.json();
        setItemList(data.data);
      } catch (err) {
        if (err.message === "404 error" || err.message === "401 error") {
          navigate("/login");
        } else {
          console.log("---- catch");
          console.log(err);
          setItemList([]);
        }
      }
    };
    getItemList();
  }, [page, token, navigate]);

  const tablelist = itemList.map((item) => (
    <DocsRow
      key={item.id}
      title={item.title}
      id={item.id}
      url={item.url}
      category={item.category_name}
    />
  ));

  return (
    <>
      <div className="announcement-header">
        <h4 className="announcement-title">説明・同意文書一覧</h4>
        <Link to="0" className="btn btn-primary">
          ＋ 新規作成
        </Link>
      </div>

      <div className="announcement-card">
        <div className="ann-row ann-row-header">
          <div className="ann-col ann-col-doc-title">タイトル</div>
          <div className="ann-col ann-col-doc-url">URL</div>
          <div className="ann-col ann-col-category">カテゴリ</div>
          <div className="ann-col ann-col-actions">操作</div>
        </div>
        {tablelist.length > 0 ? (
          <div className="ann-table-body">{tablelist}</div>
        ) : (
          <div className="ann-empty">登録されている文書がありません。</div>
        )}
      </div>
    </>
  );
};

const DocsForm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [categoryList, setCategoryList] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const fetchData = async () => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "category_list", token: token }),
      });
      if (!response.ok) {
        navigate("/");
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setCategoryList(data.data);
      }
    } catch (err) {
      console.log(err);
      setCategoryList([]);
    }
  };

  const editData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "row", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setValue("title", data.data.title);
        setValue("url", data.data.url);
        setValue("category_id", data.data.category_id);
        setValue("sortno", data.data.sortno);
      } else {
        navigate("/docs");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      await fetchData();
      if (id > 0) {
        await editData(id);
      } else {
        setValue("sortno", 100);
      }
    };
    init();
  }, [id, token, setValue]);

  const onSubmit = async (data) => {
    const post_data = {
      id: data.id,
      title: data.title,
      url: data.url,
      category_id: data.category_id,
      sortno: data.sortno,
      token: token,
      mode: "add",
    };
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      const resData = await response.json();
      if (response.ok) {
        if (resData.result) {
          navigate("/docs");
        } else {
          setError(resData.error);
        }
      } else {
        setError("失敗しました");
      }
    } catch (err) {
      console.log(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../docs" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>
        <h4 className="announcement-title">
          {id > 0 ? "説明・同意文書の編集" : "説明・同意文書の新規作成"}
        </h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <label>タイトル</label>
          <input
            type="text"
            className="frm-input"
            {...register("title", {
              required: true,
            })}
          />
          {errors.title && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>URL</label>
          <input
            type="text"
            className="frm-input"
            {...register("url", {
              required: true,
            })}
          />
          {errors.url && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>カテゴリ</label>
          <select
            name="category_id"
            className="frm-select"
            {...register("category_id", { required: true })}
          >
            <option value="">選択してください</option>
            {categoryList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {errors.category_id && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>並び順</label>
          <input
            type="number"
            className="frm-input"
            {...register("sortno", {
              required: true,
            })}
          />
          {errors.sortno && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer">
          <button type="submit" className="btn btn-primary">
            更新する
          </button>
        </div>
      </form>
    </div>
  );
};

const DocsDeleteConfirm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [viewData, setViewData] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const { register, handleSubmit } = useForm();

  const targetData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "detail", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setViewData(data.data);
      } else {
        navigate("/docs");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id > 0) {
      targetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    const post_data = {
      id: data.id,
      token: token,
      mode: "delete",
    };
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      const resData = await response.json();
      if (response.ok) {
        if (resData.result) {
          navigate("/docs");
        } else {
          setError(resData.error);
        }
      } else {
        setError("失敗しました");
      }
    } catch (err) {
      console.log(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../docs" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>
        <h4 className="announcement-title">説明・同意文書の削除確認</h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <div className="delete-warning">
            このデータを削除しますか？（元に戻せません）
          </div>
        </div>

        <div className="frm-row">
          <label>タイトル</label>
          <div className="frm-static">{viewData.title}</div>
        </div>
        <div className="frm-row">
          <label>URL</label>
          <div className="frm-static">{viewData.url}</div>
        </div>
        <div className="frm-row">
          <label>カテゴリ</label>
          <div className="frm-static">{viewData.category_name}</div>
        </div>
        <div className="frm-row">
          <label>並び順</label>
          <div className="frm-static">{viewData.sortno}</div>
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer frm-footer-between">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => navigate("/docs")}
          >
            キャンセル
          </button>
          <button type="submit" className="btn btn-danger">
            削除する
          </button>
        </div>
      </form>
    </div>
  );
};

const Docs = () => {
  return (
    <div className="announcement-page">
      <div className="sub_title">説明・同意文書</div>
      <div className="announcement-inner">
        <Routes>
          <Route path="/" element={<DocsHome />} />
          <Route path=":id" element={<DocsForm />} />
          <Route path="/delete/:id" element={<DocsDeleteConfirm />} />
        </Routes>
      </div>
    </div>
  );
};

export default Docs;
